import cloneDeep from 'lodash/cloneDeep';
import { fork, put, select, take } from 'redux-saga/effects';
import * as actions from './actions';
import { createSetCostOfEstimation, getInjector, takeFetch } from '../../../../../../helpers';
import * as serviceActions from '../../../../../services/actions';

function* init() {
  while (true) {
    const {project} = yield take(actions.INIT.BEGIN);
    const durationConverter = getInjector().get('durationService').getConverter();
    const costOfEstimationModel = durationConverter.fromMinutes(project.costOfEstimationUnit);
    yield put (actions.setEstimationUnit.begin({
      estimationUnit: project.estimationUnit})
      );

    yield put(actions.init.end({
      origProject: {...project, costOfEstimationModel},
      project: {...cloneDeep(project), costOfEstimationModel}
    }));
  }
}

function* resetChanges() {
  while (true) {
    yield take(actions.RESET_CHANGES.BEGIN);
    const {origProject} = yield select(state => state.configuration.project.editor.general.fieldset);
    yield put(actions.resetChanges.end({origProject: cloneDeep(origProject)}));
  }
}

function* setName() {
  while(true) {
    const { name } = yield take(actions.SET_NAME.BEGIN);
    let { groupId, projectId } = yield select(state => state.configuration.project.editor.general.fieldset.project);
    if(!projectId) {
      projectId = null;
    }
    if(!groupId) {
      groupId = yield select(state => state.configuration.project.editor.general.fieldset.companyId);
    }
    yield put(serviceActions.api.configuration.project.getIsProjectNameUnique.request({ name, groupId, projectId }));
    const { success } = yield takeFetch(serviceActions.api.configuration.project.GET_IS_PROJECT_NAME_UNIQUE);
    yield put(actions.setName.end({ isNameUnique: !success.data }));
  }
}

function* setCostOfEstimationUnitVisivility()
{
  while(true) {
    const { estimationUnit } = yield take(actions.SET_ESTIMATION_UNIT.BEGIN);
    
    yield put(actions.setEstimationUnit.end({ isCostOfEstUnitVisible: estimationUnit!==1 }));
  }
}

function* changeActiveFlag() {
  while(true) {
    const { name } = yield take(actions.CHANGE_ACTIVITY.BEGIN);
    let { groupId, projectId, isActive } = yield select(state => state.configuration.project.editor.general.fieldset.project);
    if(!projectId) {
      projectId = null;
    }
    if(!groupId) {
      groupId = yield select(state => state.configuration.project.editor.general.fieldset.companyId);
    }

    if(!isActive)
    {
      yield put(actions.changeActiveFlag.end({ isNameUnique: true }));
    }
    else
    {
        yield put(serviceActions.api.configuration.project.getIsProjectNameUnique.request({ name, groupId, projectId }));
        const { success } = yield takeFetch(serviceActions.api.configuration.project.GET_IS_PROJECT_NAME_UNIQUE);
        yield put(actions.changeActiveFlag.end({ isNameUnique: !success.data }));
    }
  }
}

export default function* general() {
  yield fork(init);
  yield fork(resetChanges);
  yield fork(createSetCostOfEstimation(actions));
  yield fork(setName);
  yield fork(changeActiveFlag);
  yield fork(setCostOfEstimationUnitVisivility);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/general/fieldset/saga.js